import { getPostseasonGameInfo } from 'bdata-sns-shared/utils/getGameInfoValues';

const getSeriesStatusMessage = (data) => {
    const {
        dictionary,
        gameNumber,
        result,
        shortName,
        ifNecessary,
        hideGameNumber = false,
        gameType,
        leagueID
    } = data;

    const seriesData = getPostseasonGameInfo({
        dictionary,
        shortName,
        gameNumber,
        result,
        hideGameNum: hideGameNumber,
        ifNecessary,
        gameType,
        leagueID
    });

    return {
        gameText: seriesData.gameText,
        statusText: seriesData.result,
        ifNecessaryText: seriesData.ifNecessaryText,
        seriesTextAbbrev: seriesData.seriesInfoAbbrev
    };
};

export default getSeriesStatusMessage;
